import MasterApi from '@/api/master'
import { BrandModel, CategoryModel } from '@/models/Master'

const assignBrandModel = data => {
  return data.map(o => new BrandModel(o))
}
const assignCategoryModel = data => {
  return data.map(o => new CategoryModel(o))
}

const actions = {
  async GET_BRAND_LIST({ commit }, { pageSize, pageNo, name, url }) {
    const params = {
      pageSize: pageSize,
      pageNo: pageNo,
      name: name,
      url: url,
    }
    const { items } = await MasterApi.fetchBrandList(params)
    const modeledItems = assignBrandModel(items)
    commit('SET_BRAND_LIST', modeledItems)
  },
  async CLEAR_BRAND_LIST({ commit }) {
    commit('CLEAR_BRAND_LIST')
  },
  async GET_CATEGORY_LIST({ commit }, { pageSize, pageNo, name }) {
    const params = {
      pageSize: pageSize,
      pageNo: pageNo,
      name: name,
    }
    const { items } = await MasterApi.fetchCategoryList(params)
    const modeledItems = assignCategoryModel(items)
    commit('SET_CATEGORY_LIST', modeledItems)
  },
  async CLEAR_CATEGORY_LIST({ commit }) {
    commit('CLEAR_CATEGORY_LIST')
  },
}

export default actions
